// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kb-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  align-items: flex-start;
}
.kb-table-card {
  flex: 999 1 600px;
  min-width: 0;
  overflow: hidden;
  padding-bottom: 16px;
}
.kb-aside {
  flex: 1 1 300px;
  max-width: 420px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.kb-table {
  min-width: 640px;
}
.kb-table tbody tr:hover td {
  background: var(--v2-bg);
}
.kb-table tr.is-sel td {
  background: var(--v2-bg);
}
.kb-src {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.kb-src-name {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
}
.kb-type {
  width: 30px;
  height: 30px;
  flex: none;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.kb-pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: var(--v2-hover);
  color: var(--v2-text-2);
  white-space: nowrap;
  align-self: flex-start;
}
.kb-pill.is-ok {
  background: var(--v2-green-bg);
  color: var(--v2-green-text);
}
.kb-pill.is-blue {
  background: #e0eaff;
  color: #1d4fa8;
}
.kb-pill.is-orange {
  background: var(--v2-orange-bg);
  color: var(--v2-orange);
}
.kb-pill.is-red {
  background: #fee2e2;
  color: var(--v2-red);
}
.kb-proc {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-width: 220px;
}
.kb-bar {
  height: 4px;
  border-radius: 999px;
  background: var(--v2-hover);
  overflow: hidden;
}
.kb-bar > div {
  height: 4px;
  background: var(--v2-blue);
  border-radius: 999px;
  transition: width 0.4s;
}
.kb-mini {
  height: 28px !important;
  padding: 0 10px !important;
  align-self: flex-start;
}
.kb-drop {
  margin: 14px 16px 0;
  border: 1.5px dashed #d1d5db;
  border-radius: 12px;
  padding: 18px 16px;
  text-align: center;
  color: var(--v2-muted);
  font-size: 13px;
  cursor: pointer;
}
.kb-drop b {
  color: var(--v2-text-2);
}
.kb-drop.is-drag,
.kb-drop:hover {
  border-color: var(--v2-primary);
  background: var(--v2-bg);
}
.kb-empty {
  padding: 28px 16px 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  text-align: center;
}
.kb-kv {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
}
.kb-kv > div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.kb-kv > div > span:first-child {
  color: var(--v2-muted);
}
.kb-kv-text {
  font-size: 13px;
}
.kb-ok {
  color: var(--v2-green-text);
  font-weight: 600;
}
.kb-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.kb-danger {
  color: var(--v2-red) !important;
  border-color: #fecaca !important;
}
.kb-steps {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
  font-size: 13px;
  color: var(--v2-faint);
}
.kb-steps li {
  display: flex;
  align-items: center;
  gap: 8px;
}
.kb-steps li.is-done {
  color: var(--v2-text-2);
}
.kb-steps li.is-cur {
  color: var(--v2-primary);
  font-weight: 600;
}
.kb-steps li.is-skip {
  text-decoration: line-through;
}
.kb-step-dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  border: 1.5px solid #d1d5db;
  flex: none;
}
.kb-steps li.is-done .kb-step-dot {
  border: 0;
  background: var(--v2-green-bg);
  color: var(--v2-green-text);
}
.kb-steps li.is-cur .kb-step-dot {
  border-color: var(--v2-blue);
  color: var(--v2-blue);
}
.kb-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  font-size: 13px;
}
.kb-spinner {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #d1d5db;
  border-top-color: var(--v2-primary);
  animation: kb-spin 0.9s linear infinite;
  flex: none;
}
@keyframes kb-spin {
  to {
    transform: rotate(360deg);
  }
}
.kb-toast {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 50;
  width: 400px;
  max-width: calc(100vw - 48px);
  background: #fff;
  border: 1px solid var(--v2-border);
  border-radius: 14px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.kb-toast-ok {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--v2-green-bg);
  color: var(--v2-green-text);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
}
.kb-toast-sugg {
  background: var(--v2-blue-bg);
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
}
/* Окно загрузки (5а) */
.up-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 68vh;
  overflow-y: auto;
  padding-right: 2px;
}
.up-drop {
  display: flex;
  align-items: center;
  gap: 14px;
  border: 1.5px dashed #d1d5db;
  border-radius: 12px;
  padding: 14px 18px;
  cursor: pointer;
  color: var(--v2-primary);
}
.up-drop.is-drag,
.up-drop:hover {
  border-color: var(--v2-primary);
  background: var(--v2-bg);
}
.up-list {
  border: 1px solid var(--v2-border);
  border-radius: 12px;
  overflow: hidden;
}
.up-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-top: 1px solid var(--v2-border-soft);
}
.up-row:first-child {
  border-top: 0;
}
.up-row.is-child {
  padding-left: 30px;
  border-left: 0;
  position: relative;
}
.up-row.is-child::before {
  content: '';
  position: absolute;
  left: 20px;
  top: 8px;
  bottom: 8px;
  border-left: 1px solid var(--v2-border);
}
.up-row.is-error {
  background: #fef2f2;
}
.up-name {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.up-price {
  font-weight: 600;
  white-space: nowrap;
  font-size: 13px;
}
.up-x {
  border: 0;
  background: transparent;
  color: var(--v2-faint);
  font-size: 18px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  flex: none;
}
.up-x:hover {
  background: var(--v2-hover);
  color: var(--v2-primary);
}
.up-switch-card {
  display: flex;
  gap: 16px;
  align-items: center;
  border: 1px solid var(--v2-border);
  border-radius: 12px;
  padding: 12px 14px;
}
.up-sum {
  background: var(--v2-bg);
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
}
.up-sum-row {
  display: flex;
  justify-content: space-between;
  color: var(--v2-text-2);
}
.up-sum-total {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  border-top: 1px solid var(--v2-border);
  padding-top: 8px;
  margin-top: 2px;
  font-weight: 700;
  font-size: 14px;
}
.up-sum-total span:last-child {
  font-size: 16px;
}
.up-short {
  background: var(--v2-orange-bg);
  border: 1px solid #fde7c2;
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  gap: 12px;
  align-items: center;
}
.up-foot {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 14px;
}

/* База знаний: подробности источника справа, пока таблица помещается целиком
   (≈ от 1200 px окна). Уже — таблица на всю ширину, подробности над ней по клику. */
.kb-grid.is-kb {
  container-type: inline-size;
}
/* Карточка источника одной ширины — длинное имя файла обрезаем многоточием */
.kb-grid.is-kb > .kb-aside {
  flex: 0 0 380px;
  width: 380px;
  max-width: 380px;
  min-width: 0;
}
.kb-aside .kb-src > div {
  flex: 1;
  min-width: 0;
}
.kb-aside .kb-src-name {
  white-space: nowrap;
}
.kb-aside-x {
  display: none;
  margin-left: auto;
  width: 26px;
  height: 26px;
  flex: none;
}
@container (max-width: 940px) {
  .kb-grid.is-kb .kb-aside-x {
    display: flex;
  }
  .kb-grid.is-kb > .kb-aside {
    order: -1;
    width: auto;
    max-width: none;
    flex: 1 1 100%;
  }
  .kb-grid.is-kb > .kb-aside:not(.is-picked) {
    display: none;
  }
}

/* Выбор нескольких источников и удаление разом */
.kb-table .kb-check {
  width: 36px;
  padding-right: 0;
}
.kb-check input {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--v2-primary);
}
.kb-check input:disabled {
  cursor: default;
}
.kb-selbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 16px;
  background: var(--v2-bg);
  border-bottom: 1px solid var(--v2-border);
  font-size: 13px;
  font-weight: 600;
}
.kb-proc.is-row {
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}
`, "",{"version":3,"sources":["webpack://./src/pages/knowledge/knowledge.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,uCAAuC;EACvC,UAAU;AACZ;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;AACA;;EAEE,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,uCAAuC;AACzC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;oFACoF;AACpF;EACE,2BAA2B;AAC7B;AACA,6EAA6E;AAC7E;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".kb-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  align-items: flex-start;\n}\n.kb-table-card {\n  flex: 999 1 600px;\n  min-width: 0;\n  overflow: hidden;\n  padding-bottom: 16px;\n}\n.kb-aside {\n  flex: 1 1 300px;\n  max-width: 420px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.kb-table {\n  min-width: 640px;\n}\n.kb-table tbody tr:hover td {\n  background: var(--v2-bg);\n}\n.kb-table tr.is-sel td {\n  background: var(--v2-bg);\n}\n.kb-src {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n.kb-src-name {\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.kb-type {\n  width: 30px;\n  height: 30px;\n  flex: none;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n.kb-pill {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 9px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  background: var(--v2-hover);\n  color: var(--v2-text-2);\n  white-space: nowrap;\n  align-self: flex-start;\n}\n.kb-pill.is-ok {\n  background: var(--v2-green-bg);\n  color: var(--v2-green-text);\n}\n.kb-pill.is-blue {\n  background: #e0eaff;\n  color: #1d4fa8;\n}\n.kb-pill.is-orange {\n  background: var(--v2-orange-bg);\n  color: var(--v2-orange);\n}\n.kb-pill.is-red {\n  background: #fee2e2;\n  color: var(--v2-red);\n}\n.kb-proc {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  max-width: 220px;\n}\n.kb-bar {\n  height: 4px;\n  border-radius: 999px;\n  background: var(--v2-hover);\n  overflow: hidden;\n}\n.kb-bar > div {\n  height: 4px;\n  background: var(--v2-blue);\n  border-radius: 999px;\n  transition: width 0.4s;\n}\n.kb-mini {\n  height: 28px !important;\n  padding: 0 10px !important;\n  align-self: flex-start;\n}\n.kb-drop {\n  margin: 14px 16px 0;\n  border: 1.5px dashed #d1d5db;\n  border-radius: 12px;\n  padding: 18px 16px;\n  text-align: center;\n  color: var(--v2-muted);\n  font-size: 13px;\n  cursor: pointer;\n}\n.kb-drop b {\n  color: var(--v2-text-2);\n}\n.kb-drop.is-drag,\n.kb-drop:hover {\n  border-color: var(--v2-primary);\n  background: var(--v2-bg);\n}\n.kb-empty {\n  padding: 28px 16px 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: center;\n  text-align: center;\n}\n.kb-kv {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 13px;\n}\n.kb-kv > div {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n.kb-kv > div > span:first-child {\n  color: var(--v2-muted);\n}\n.kb-kv-text {\n  font-size: 13px;\n}\n.kb-ok {\n  color: var(--v2-green-text);\n  font-weight: 600;\n}\n.kb-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.kb-danger {\n  color: var(--v2-red) !important;\n  border-color: #fecaca !important;\n}\n.kb-steps {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  font-size: 13px;\n  color: var(--v2-faint);\n}\n.kb-steps li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.kb-steps li.is-done {\n  color: var(--v2-text-2);\n}\n.kb-steps li.is-cur {\n  color: var(--v2-primary);\n  font-weight: 600;\n}\n.kb-steps li.is-skip {\n  text-decoration: line-through;\n}\n.kb-step-dot {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  border: 1.5px solid #d1d5db;\n  flex: none;\n}\n.kb-steps li.is-done .kb-step-dot {\n  border: 0;\n  background: var(--v2-green-bg);\n  color: var(--v2-green-text);\n}\n.kb-steps li.is-cur .kb-step-dot {\n  border-color: var(--v2-blue);\n  color: var(--v2-blue);\n}\n.kb-banner {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  font-size: 13px;\n}\n.kb-spinner {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid #d1d5db;\n  border-top-color: var(--v2-primary);\n  animation: kb-spin 0.9s linear infinite;\n  flex: none;\n}\n@keyframes kb-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.kb-toast {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  z-index: 50;\n  width: 400px;\n  max-width: calc(100vw - 48px);\n  background: #fff;\n  border: 1px solid var(--v2-border);\n  border-radius: 14px;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.kb-toast-ok {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: var(--v2-green-bg);\n  color: var(--v2-green-text);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n}\n.kb-toast-sugg {\n  background: var(--v2-blue-bg);\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 13px;\n}\n/* Окно загрузки (5а) */\n.up-body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: 68vh;\n  overflow-y: auto;\n  padding-right: 2px;\n}\n.up-drop {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  border: 1.5px dashed #d1d5db;\n  border-radius: 12px;\n  padding: 14px 18px;\n  cursor: pointer;\n  color: var(--v2-primary);\n}\n.up-drop.is-drag,\n.up-drop:hover {\n  border-color: var(--v2-primary);\n  background: var(--v2-bg);\n}\n.up-list {\n  border: 1px solid var(--v2-border);\n  border-radius: 12px;\n  overflow: hidden;\n}\n.up-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  border-top: 1px solid var(--v2-border-soft);\n}\n.up-row:first-child {\n  border-top: 0;\n}\n.up-row.is-child {\n  padding-left: 30px;\n  border-left: 0;\n  position: relative;\n}\n.up-row.is-child::before {\n  content: '';\n  position: absolute;\n  left: 20px;\n  top: 8px;\n  bottom: 8px;\n  border-left: 1px solid var(--v2-border);\n}\n.up-row.is-error {\n  background: #fef2f2;\n}\n.up-name {\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.up-price {\n  font-weight: 600;\n  white-space: nowrap;\n  font-size: 13px;\n}\n.up-x {\n  border: 0;\n  background: transparent;\n  color: var(--v2-faint);\n  font-size: 18px;\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  flex: none;\n}\n.up-x:hover {\n  background: var(--v2-hover);\n  color: var(--v2-primary);\n}\n.up-switch-card {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  border: 1px solid var(--v2-border);\n  border-radius: 12px;\n  padding: 12px 14px;\n}\n.up-sum {\n  background: var(--v2-bg);\n  border-radius: 12px;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 13px;\n}\n.up-sum-row {\n  display: flex;\n  justify-content: space-between;\n  color: var(--v2-text-2);\n}\n.up-sum-total {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  border-top: 1px solid var(--v2-border);\n  padding-top: 8px;\n  margin-top: 2px;\n  font-weight: 700;\n  font-size: 14px;\n}\n.up-sum-total span:last-child {\n  font-size: 16px;\n}\n.up-short {\n  background: var(--v2-orange-bg);\n  border: 1px solid #fde7c2;\n  border-radius: 12px;\n  padding: 12px 14px;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n.up-foot {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-top: 14px;\n}\n\n/* База знаний: подробности источника справа, пока таблица помещается целиком\n   (≈ от 1200 px окна). Уже — таблица на всю ширину, подробности над ней по клику. */\n.kb-grid.is-kb {\n  container-type: inline-size;\n}\n/* Карточка источника одной ширины — длинное имя файла обрезаем многоточием */\n.kb-grid.is-kb > .kb-aside {\n  flex: 0 0 380px;\n  width: 380px;\n  max-width: 380px;\n  min-width: 0;\n}\n.kb-aside .kb-src > div {\n  flex: 1;\n  min-width: 0;\n}\n.kb-aside .kb-src-name {\n  white-space: nowrap;\n}\n.kb-aside-x {\n  display: none;\n  margin-left: auto;\n  width: 26px;\n  height: 26px;\n  flex: none;\n}\n@container (max-width: 940px) {\n  .kb-grid.is-kb .kb-aside-x {\n    display: flex;\n  }\n  .kb-grid.is-kb > .kb-aside {\n    order: -1;\n    width: auto;\n    max-width: none;\n    flex: 1 1 100%;\n  }\n  .kb-grid.is-kb > .kb-aside:not(.is-picked) {\n    display: none;\n  }\n}\n\n/* Выбор нескольких источников и удаление разом */\n.kb-table .kb-check {\n  width: 36px;\n  padding-right: 0;\n}\n.kb-check input {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: var(--v2-primary);\n}\n.kb-check input:disabled {\n  cursor: default;\n}\n.kb-selbar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 10px 16px;\n  background: var(--v2-bg);\n  border-bottom: 1px solid var(--v2-border);\n  font-size: 13px;\n  font-weight: 600;\n}\n.kb-proc.is-row {\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
